var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewApplicationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 33,
    viewBox: "0 0 92 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Crea_offerta",
    "data-name": "Crea offerta",
    transform: "translate(-851 -670)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_54",
    "data-name": "Rettangolo 54",
    width: 92,
    height: 33,
    transform: "translate(851 670)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_38",
    "data-name": "Raggruppa 38",
    transform: "translate(432 -331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Unione_2",
    "data-name": "Unione 2",
    d: "M16644-992a14,14,0,0,1,14-14,14,14,0,0,1,14,14,14,14,0,0,1-14,14A14,14,0,0,1,16644-992Zm5.516-8.485A11.921,11.921,0,0,0,16646-992a11.921,11.921,0,0,0,3.516,8.485A11.916,11.916,0,0,0,16658-980a11.921,11.921,0,0,0,8.486-3.515A11.919,11.919,0,0,0,16670-992a11.919,11.919,0,0,0-3.514-8.485A11.938,11.938,0,0,0,16658-1004,11.934,11.934,0,0,0,16649.516-1000.486ZM16657-984v-6.527h-6.527a1,1,0,0,1-1-1,1,1,0,0,1,1-1H16657v-6.531a1,1,0,0,1,1-1,1,1,0,0,1,1,1v6.531h6.527a1,1,0,0,1,1,1,1,1,0,0,1-1,1H16659V-984a1,1,0,0,1-1,1A1,1,0,0,1,16657-984Z",
    transform: "translate(-16193 2009)",
    fill: "#8b8d8e"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewApplicationIcon);
export default __webpack_public_path__ + "static/media/new-application-icon.bc1b945d7d37957ccce4416ac80f79fc.svg";
export { ForwardRef as ReactComponent };